import { LocalStorage } from "@/shared/core/localStorage";
import { Locales } from "@/shared/core/constants";

export class LocaleHelper {

    // take culture for locale translations. es-MX keeps its own overrides; other cultures that start with es are translated into es-ES
    // If user selects culture, return selected
    static toLocaleCulture(culture: string): string {
        const storedCulture = LocalStorage.get("lcl");
        if (storedCulture !== null && storedCulture.split("-")[0] !== culture.split("-")[0]) {
            culture = storedCulture;
        }
        if (culture === Locales.esMX) {
            return culture;
        }
        return culture.split("-")[0] === "es" ? "es-ES" : culture;
    }
}
